import styled from "styled-components";

import { DATA_E2E_KEY, IStyledAttributes } from "@ryde/shared";
import {
  greyMui,
  MOBILE_BREAKPOINT,
  rydeColors,
  ScreenDepth,
} from "@ryde/theme";

export const PageHeaderStyled = styled.header.attrs<IStyledAttributes>({
  "data-e2e": "page-header",
})`
  background-color: ${rydeColors.smoke};
  display: flex;
  flex-direction: column;
  align-items: stretch;
  position: relative;
  z-index: ${ScreenDepth.HEADER};
`;

export const PageHeaderFirstLine = styled.div.attrs<IStyledAttributes>({
  "data-e2e": "page-header-first-line",
})`
  min-height: 56px;
  display: flex;
  align-items: center;
  border-bottom: 1px solid ${greyMui._300};
  background-color: ${rydeColors.white};

  .header-top-global-search {
    margin-inline-start: 16px;
  }
`;

export const PageHeaderMobileStyled = styled.header.attrs<IStyledAttributes>({
  "data-e2e": "page-header-mobile",
})`
  background-color: ${rydeColors.white};
  display: flex;
  align-items: center;
  top: 0;
  .buttons-container {
    display: flex;
    margin-inline-start: auto;
    .add-button {
      cursor: pointer;
      @media (max-width: ${MOBILE_BREAKPOINT}) {
        padding-inline-start: 4px;
        padding-inline-end: 2px;
      }
    }
    .filter-apply-button {
      cursor: pointer;
      @media (max-width: ${MOBILE_BREAKPOINT}) {
        padding-inline-start: 2px;
      }
    }
  }

  z-index: ${ScreenDepth.HEADER_MOBILE};
  border-bottom: 1px solid ${greyMui._300};
  position: sticky;
`;

export const PageHeaderMobileContainerStyled = styled.div.attrs<IStyledAttributes>(
  {
    [DATA_E2E_KEY]: "page-header-mobile-container",
  },
)`
  display: flex;
  flex-direction: column;
  flex-shrink: 0;
  width: 100%;

  .mobile-header-second-line {
    display: flex;
    flex-direction: column;
    align-self: stretch;
    width: 100%;
  }
`;

export const FilterFieldsMobileWrapper = styled.div.attrs<IStyledAttributes>({
  "data-e2e": "filter-fields-mobile-wrapper",
})`
  margin-top: 20px;
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: stretch;
  justify-content: flex-start;
  gap: 10px;
`;

export const ViewsPanelWrapperMobile = styled.div.attrs<IStyledAttributes>({
  "data-e2e": "views-panel-mobile",
})`
  width: 100%;
  margin-top: 20px;
  height: 30px;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 10px;
`;

export const HeaderRightButtonsStyled = styled.div.attrs<IStyledAttributes>({
  [DATA_E2E_KEY]: "header-right-buttons",
})`
  margin-inline-start: auto;
  display: flex;
  align-items: center;
  gap: 5px;
  padding-inline-end: 10px;
  svg {
    cursor: pointer;
    text-decoration: none;
  }
  @media (max-width: ${MOBILE_BREAKPOINT}) {
    padding-inline-end: 10px;
  }
`;
